module.exports = __webpack_public_path__ + "img/Hickory Radio2.7ff113c6.png";